module.exports = __webpack_public_path__ + "img/pasture_panicum_low.7f748028.jpg";